<template>
    <div>
        <app-contratacao
            :contratacao="contratacao"
            :movimentosServicos="obterMovimentosServicos()"
            :contratacoesServicos="obterContratacoesServicos()"
            @obterAtualizacao="obterContratacao()"
            v-show="mostrarContratacao"
            v-if="contratacao"
        >
            <template slot="contratacaoFooter">
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click="detalharRateios()"
                    v-if="$temAcessoView('CRED-UABS-RAT-00')"
                    class="ml-2"
                    ><i class="fa fa-pie-chart"></i> Rateios</b-button
                >
            </template>
            <template slot="entregaAcoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-UABS-ENTR-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
        </app-contratacao>
        <router-view
            @obterAtualizacao="obterContratacao()"
            v-if="contratacao"
        ></router-view>
    </div>
</template>

<script>
import ContratacoesServicos from './ContratacoesServicos'
import MovimentosServicos from './../movimentos/MovimentosServicos'
import Contratacao from '@/app/credenciados/componentes/contratacoes/Contratacao'

export default {
    data() {
        return {
            contratacao: null
        }
    },

    methods: {
        obterContratacao() {
            this.$store.dispatch('addRequest')
            ContratacoesServicos.obterPorId(
                this.$route.params.contratacaoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratacao = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter contratação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Uabs_Entregas_Detalhar',
                params: {
                    entregaId: entregaId
                }
            })
        },

        detalharRateios() {
            this.$router.push({
                name: 'Uabs_Contratacoes_Rateios'
            })
        },

        obterMovimentosServicos() {
            return MovimentosServicos
        },

        obterContratacoesServicos() {
            return ContratacoesServicos
        }
    },

    computed: {
        mostrarContratacao() {
            return this.$route.name == 'Uabs_Contratacoes_Detalhar'
        }
    },

    created() {
        this.obterContratacao()
    },

    components: {
        AppContratacao: Contratacao
    }
}
</script>
